<script setup lang="ts">
import { onMounted, ref } from 'vue'
import type { BubbleProps } from '../types'
import BubbleButton from './BubbleButton.vue'
import { cn } from '@/lib/utils'
import { ChatHeader } from '@/components/Bubble'
import type { CommandData } from '@/features/Commands'
import ChatBody from '@/components/Bubble/ChatBody.vue'

const props = defineProps<BubbleProps>()

const botOpen = ref<boolean>(false)
const botStarted = ref<boolean>(false)

function openBot() {
  if (!botStarted.value)
    botStarted.value = true
  botOpen.value = true
  if (botOpen.value)
    props.onOpen?.()
}

function closeBot() {
  botOpen.value = false
  if (!botOpen.value)
    props.onClose?.()
}

function toggleBot() {
  botOpen.value ? closeBot() : openBot()
}

onMounted(() => {
  window.addEventListener('message', processIncomingEvent)
})

function processIncomingEvent(event: MessageEvent<CommandData>) {
  const { data } = event
  if (!data.isFromBeeetle)
    return
  if (data.command === 'open')
    openBot()
  if (data.command === 'close')
    closeBot()
  if (data.command === 'toggle')
    toggleBot()
}
</script>

<template>
  <BubbleButton
    v-bind="{ ...props.theme?.button }"
    :is-bot-opened="botOpen"
    :toggle-bot="toggleBot"
    :placement="props.theme?.placement"
  />
  <div
    :class="cn(
      'chat-container',
      props.theme?.placement === 'left'
        ? 'left-5 origin-bottom-left'
        : 'right-5 origin-bottom-right',
      botOpen ? 'opacity-100 scale-100' : 'opacity-0 scale-0',
    )"
  >
    <div tabindex="-1" role="region">
      <div class="chat-main-wrapper">
        <main id="spaces-messages" class="chat-main">
          <div
            class="header-cover"
          />
          <div class="chat-body">
            <div>
              <div
                :class="cn(
                  'body-container',
                  botOpen ? 'opacity-100' : 'opacity-0',
                )"
              >
                <div
                  class="body-wrapper"
                >
                  <ChatHeader :visible="true" :close="closeBot" />
                  <!-- conversation -->
                  <ChatBody :api="apiHost" />
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  </div>
</template>